import { makeAutoObservable } from 'mobx'

/**
 * @class NotificationsStore
 * @description This class represents the store for notification. It manages the state of notification and is part of the root store.
 */
class NotificationsStore {
	/**
	 * @property {Object} notifications - An object containing notification indexed by their IDs.
	 */
	notifications = {}

	/**
	 * @constructor
	 * @param {Object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of NotificationsStore and makes it observable.
	 */
	constructor(rootStore) {
		this.rootStore = rootStore
		makeAutoObservable(this)
	}
}

export default NotificationsStore
